import { render, staticRenderFns } from "./PaymentExportItemExtract.vue?vue&type=template&id=39db71ee&scoped=true"
import script from "./PaymentExportItemExtract.vue?vue&type=script&lang=js"
export * from "./PaymentExportItemExtract.vue?vue&type=script&lang=js"
import style0 from "./PaymentExportItemExtract.vue?vue&type=style&index=0&id=39db71ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db71ee",
  null
  
)

export default component.exports